import { applyConfigurationModelSimple, interpretConfigurationModelSimple } from "@dataspecer/core-v2/configuration-model";
import { defaultConfiguration } from "./default-configuration.js";
/**
 * Configuration key for the documentation generator.
 */
export const DOCUMENTATION_CONFIGURATION_KEY = "https://schemas.dataspecer.com/documentation-generator-config/";
export const DOCUMENTATION_MAIN_TEMPLATE_PARTIAL = "specification";
export const defaultPartialDocumentationConfiguration = {
    partials: {},
};
export function createPartialDocumentationConfiguration(configuration) {
    return interpretConfigurationModelSimple(configuration, DOCUMENTATION_CONFIGURATION_KEY, defaultPartialDocumentationConfiguration);
}
export function applyPartialDocumentationConfiguration(configurationModel, configuration) {
    applyConfigurationModelSimple(configurationModel, DOCUMENTATION_CONFIGURATION_KEY, configuration);
}
/**
 * Default configuration for the documentation generator.
 *
 * Because the default configuration is not complete due to other generators, you may need to merge it with other configurations to get a complete configuration.
 * @see defaultDocumentationConfiguration from {@link @dataspecer/specification}.
 */
export const internalDefaultDocumentationConfiguration = defaultConfiguration;
/**
 * Merges documentation configurations into a final configuration. It already includes the default configuration.
 *
 * Because the default configuration is not complete due to other generators, you may need to merge it with other configurations to get a complete configuration.
 * @see mergeDocumentationConfigurations from {@link @dataspecer/specification}.
 */
export function internalMergeDocumentationConfigurations(configurations) {
    const result = structuredClone(internalDefaultDocumentationConfiguration);
    for (const configuration of configurations) {
        for (const key in configuration.partials) {
            if (configuration.partials[key] === false) {
                delete result.partials[key];
            }
            else {
                result.partials[key] = configuration.partials[key];
            }
        }
    }
    return result;
}
//# sourceMappingURL=configuration.js.map